export default "__VITE_ASSET__CHaQP5Qz__"